<ng-container>
  <div class="field-container">
    <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
    <p-datepicker [(ngModel)]="value" [showTime]="true" [hourFormat]="'12'" size="small" placeholder="dd/mm/aaaa hh:mm"
      class="w-full" appendTo="body" showIcon [ngClass]="recovery ? 'recover-data' : ''" iconDisplay="input"
      dateFormat="dd/mm/yy" [disabled]="disabled" autocomplete="off" [showOnFocus]="false"
      (ngModelChange)="changeDate($event)" />
  </div>
</ng-container>